import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import PlayerCount from './PlayerCount';
import {
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

const styles = {
  text: {
    color: 'white',
  },
  progress: {
    marginLeft: '8px',
  },
};

class DiscordButton extends React.Component {
  constructor() {
    super();
    this.state = {
      nb: 0,
      loading: true,
    };
    this.checks = 40;
    this.checkPlayerCount = this.checkPlayerCount.bind(this);
    this.updatePlayerCount = this.updatePlayerCount.bind(this);
  }

  componentDidMount() {
    this.updatePlayerCount();
  }

  checkPlayerCount() {
    fetch('https://discordapp.com/api/guilds/217700360335261697/widget.json')
      .then(res => res.json())
      .then(data => this.setState({ nb: data.presence_count, loading: false }))
      .catch((error) => {
        this.setState({ nb: 404, loading: false });
      });
  }

  updatePlayerCount() {
    this.checkPlayerCount();
    this.checks -= 1;
    if (this.checks > 0) setTimeout(this.updatePlayerCount, 7000);
  }

  render() {
    const { loading, nb } = this.state;
    const playerNb = (loading)
      ? (
        <CircularProgress
          size={15}
          thickness={5}
          color="inherit"
          style={styles.progress}
        />
      )
      : nb;

    return (
      <React.Fragment>
        
        <a
            href="https://discord.gg/YC4XPGp"
            target="_blank"
            variant="contained"
            className="play animationRipple">

            <Grid xs={12} sm={12} md={12} container>
              
              <Grid xs={3} sm={3} md={3} item>
                <img
                  src="./discord.png"
                  alt="BloodyBattle"
                  width="55px"
                />
              </Grid>
              <Grid xs={9} sm={9} md={9} item>
                
            <Grid xs={12} sm={12} md={12} container>
              <span className="title">Rejoins Discord!</span>
            </Grid>
            <Grid xs={12} sm={12} md={12} container>
                <span className="subtitle">{playerNb} Joueurs en ligne !</span>
            </Grid>
              </Grid>
            </Grid>
          </a>
        
      </React.Fragment>
    );
  }
}

export default DiscordButton;



// WEBPACK FOOTER //
// ./src/layout/DiscordButton.js